package com.wintermar.inspection.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.navigation3.runtime.NavBackStack
import androidx.navigation3.runtime.NavKey
import kotlinx.browser.window

@Composable
actual fun BindNavigationToPlatform(
    rootBackStack: NavBackStack<NavKey>,
    currentRoute: Route?
) {
    // 1. Listen for Browser URL changes (URL -> App)
    LaunchedEffect(Unit) {
        window.onhashchange = {
            val hash = window.location.hash.removePrefix("#")
            val newRoute = when {
                hash.startsWith(RoutePath.INSPECTION.path) -> Route.Inspection
                hash.startsWith(RoutePath.TEMPLATE.path) -> Route.Template
                else -> null  // ignore internal/unknown hashes (e.g. "/" from Splash)
            }

            if (newRoute != null && rootBackStack.lastOrNull() != newRoute) {
                rootBackStack.clear()
                rootBackStack.add(newRoute)
            }
        }
    }

    // 2. Sync App state to Browser Address Bar (App -> URL)
    LaunchedEffect(currentRoute) {
        if (currentRoute != null) {
            val hash = when (currentRoute) {
                is Route.Inspection -> RoutePath.INSPECTION.path
                is Route.Template -> RoutePath.TEMPLATE.path
                else -> null  // don't touch the hash for Splash, Auth, Logout, etc.
            }
            if (hash != null && window.location.hash != "#$hash") {
                window.location.hash = hash
            }
        }
    }
}
